<template>
  <div id="choicePeopleComponent">
    <hr-dialog title="添加部门" :allowFull='false' width="50%" :visible.sync="visible">
      <template slot="body">
        <div class="main" style="display:flex">
          <div class="left" style="width:50%">
            <!-- <el-radio-group v-model="tabObject" style="margin-bottom: 30px;">
              <el-radio-button label="dept">部门</el-radio-button>
              <el-radio-button v-if="choiceModel=='singlePeople'||choiceModel=='people'||choiceModel=='unlimitPeople'" label="team">班组</el-radio-button>
            </el-radio-group> -->

            <div v-show="tabObject == 'dept'" class="dept">
              <div class="navigation_bar">
                <div
                  @click="navBarClick(item, index)"
                  v-for="(item, index) in navigationBarList"
                  :key="index"
                  :style="
                    index == navigationBarList.length - 1 ? 'color:#303133' : 'color:#909399 '
                  "
                >
                  {{ item.title }}<span v-if="index < navigationBarList.length - 1"> > </span>
                </div>
              </div>
              <div  v-if="choiceModel=='unlimitDept'">
                <div style="margin: 16px 0;"></div>
                <el-checkbox v-model="currentObjectDept.isAllCheck"  @change="handleCheckAllChange">全选</el-checkbox>
                
              </div>
              <div style="margin: 16px 0;"></div>
              <div
                v-for="(item, index) in nowDeptList"
                :key="index"
                class="choice_item"
                style="display:flex;justify-content: space-between;margin-bottom:16px"
              >
               <div>
                  <el-checkbox
                  v-model="item.isChecked"
                  @change="
                    () => {
                      clickCheckBox(item, selectDeptList);
                    }
                  "
                  :indeterminate='item.halfCheck'
                  >
                   <!-- showHalf(item.checkSum,item) -->
                    
                  </el-checkbox
                >
                <span >
                       <span>
                        {{ item.title }}
                      </span>
                      
                </span>
               </div>
                <div v-if="item.children" style="display: flex;align-items: center;cursor:pointer;">
                  
                  <div style="height: 14px;border-left: 1px solid #DCDFE6;width:10px"></div>
                  <div @click.stop="goSubordinate(item)" :style="item.isChecked?'color:#C0C4CC;':''" class="subordinateLable">
                    下级
                  </div>
                </div>
              </div>
             
            </div>
           
          </div>

          <div class="right" style="width:50%;border-left: 1px solid #DCDFE6;">
            <div class="searchArea" >
              <el-form
                :model="searchForm"
                ref="searchFormRef"
              >
                <el-row style="margin-left:0px" :gutter="24">
                  <el-col :span="18" style="padding-right:0">
                    <el-form-item  prop="projectId">
                         <el-popover
                            placement="bottom"
                            :close-on-click-modal='true'
                           
                            trigger="manual"
                            
                            v-model="searchResultVisible">
                             <el-input  slot="reference" clearable v-model="searchFrom.value" placeholder="部门"></el-input>
                              <div v-if="searchResultDeptList.length<=0" style="text-align: center;">
                                  <span style="color:#c0c4cc">未匹配到结果</span>
                                </div>
                              <div  v-else class="searchResult">
                                <div
                                  v-for="(item, index) in searchResultDeptList"
                                  :key="index"
                                  class="searchChoice_item"
                                  style="display:flex;justify-content: space-between;margin-bottom:16px"
                                >
                                  <div>
                                    <el-checkbox
                                    v-model="item.isChecked"
                                    @change="
                                      () => {
                                        clickSearchDeptCheckBox(item,selectDeptList);
                                      }
                                    "
                                    ></el-checkbox
                                  >
                                  <span v-html="item.nameCopy"></span>
                                  <span v-if="item.searchCopy" v-html="item.searchCopy"></span>
                                  </div>
                                </div>
                              </div>
                          </el-popover>
                      <!-- <el-input v-model="searchFrom.value" placeholder="姓名、电话"></el-input> -->
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <div style="text-align: right;">
                      <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click.stop="searchRecord"
                        size="small"
                      >
                        搜索
                      </el-button>
                     
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="selectInfo">
              <div v-for="(item, index) in selectDeptList" :key="index" class="selectItem">
                  <el-tag type="info" disable-transitions :key="item" closable @close="selectDeptListDelete(item, selectDeptList)"> {{ item.title}} </el-tag>
              </div>
              
            </div>
            <div class="btnArea" style="text-align:right;">
              <el-button
                size="small"
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="submitSelect"
                style="margin-right: 16px"
                >
                  <span>确定</span>
                  <span  style="margin-left:8px;line-height: 14px;"  v-if="option.model=='singleDept'">({{checkedDeptNum!=0?checkedDeptNum+'/1':checkedDeptNum+'/1'}})</span>
                  <span  style="margin-left:8px;line-height: 14px;"  v-if="option.model=='dept'">({{checkedDeptNum}}/{{option.limit}})</span>
                  <span  style="margin-left:8px;line-height: 14px;"  v-if="option.model=='unlimitDept'">{{checkedDeptNum!=0?'('+checkedDeptNum+')':''}}</span>
                </el-button
              >
              <el-button style="margin-left: 0px" @click="closeRecord" size="small" icon="el-icon-circle-close">取 消</el-button>
            </div>
          </div>
        </div>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import {
  treeByProjectDeptId,
  treeByDeptId
} from './index.js';

export default {
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    option: {
      default: {
        projectId: '1337635452094083074',
        variable:'',
        searchType:'',
        deptId: '',
        model:'singlePeople',//singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList:[
        
          {
            id: "1466297888857010178",
            realName: "鸿润"
          }
        ],//已选的集合
        prohibitList:[
          {
            id: "1401897922670817282"
          }
        ],//禁止选的集合
        limit:2
      },
    },
  },
 
  
  data() {
    return {
      checkedDeptNum:0,
      additionalFiled:'',
      submitList:[],
      searchResultDeptList:[],//搜索部门结果
        searchFrom:{
            value:''
        },//搜索条件对象
      tabObject: 'dept',
      loading:false,
      checkAll: false,//部门全选
      groupCheckAll:false,//班组全选
      searchResultVisible:false,
      isIndeterminate: true,
      nowDeptList: [], //当前展示的部门列表
      deptData: [], //最上级的部门列表,
      navigationBarList: [], //导航栏数据
      currentObjectDept: {
        peopleListInfo: {
          peopleList: [],
          parent: null,
        },
      }, //当前展示对象的数据（展示人员信息）
      selectDeptList: [], //已选部门集合
      okBtnLable:"",
      wholeModel:'',//全局模式，判断是选人组件还是选部门组件
      choiceModel:'',//选择模式，细分模式
    };
  },
  created() {
    this.tackleModel()
    
    console.log("daying")
    this.getDeptTree();
   
  },
  watch:{
    visible(){
      this.$emit('update:visible', false);
    }
  },
  mounted(){
    
  },
 methods: {
    calculateModel(){
       if(this.option.model == "people"||this.option.model == "singlePeople"||this.option.model == "unlimitPeople"){
         this.wholeModel = 'people'
       }else{
         this.wholeModel = 'dept'
       }
    },
    goUpCalculateSelectStatus(dept){
      this.calculateSelectStatus(dept)
      if(dept.parent){
        this.goUpCalculateSelectStatus(dept.parent)
      }
    },
    selectDeptListDelete(item,data){
      item.checkSum = 0
      item.isChecked = false
      item.halfCheck = false
      this.setDeptStatus(item,false)
      this.removeItemFormData(item,data)
      this.calculateSelectDeptSum(item.parent,item.userSum,'reduce')
      this.goUpCalculateSelectStatus(item)
    },
    calculatePeopleSum(){
      let sum = 0 
      if(this.choiceModel == 'dept'){ 
        sum+=this.selectDeptList.length
        if(sum>0){
           this.okBtnLable = "(" +sum+'/'+this.option.limit+ ")"
        }else{
           this.okBtnLable = ""
        }
      }
       if(this.choiceModel == 'unlimitDept'){ 
        sum+=this.selectDeptList.length
        if(sum>0){
           this.okBtnLable = "(" +sum+ ")"
        }else{
           this.okBtnLable = ""
        }
      }
      if(this.choiceModel == 'singleDept'){ 
        sum+=this.selectDeptList.length
        if(sum>0){
           this.okBtnLable = "(" +sum+'/'+1+ ")"
        }else{
           this.okBtnLable = ""
        }
      }
      this.checkedDeptNum = sum
    },
    closeRecord(){
      this.$emit('update:visible', false);
    },
    tackleModel(){
      this.option.projectId =this.option.projectId||'1466302606614343681'
      this.option.model = this.option.model || "singleDept"
      this.option.limit = this.option.limit || 1
      this.option.variable = this.option.variable || 3
      this.option.searchType = this.option.searchType || 'phone'
      this.additionalFiled = this.option.searchType
      if(!(this.option.selectList&&this.option.selectList.length>0)){
        this.option.selectList = []
      }else{
          if(this.option.model == "people"||this.option.model == "singlePeople"||this.option.model == "unlimitPeople"){
            this.selectPeopleList = this.option.selectList
          }else{
            this.selectDeptList = this.option.selectList
          }
      }
      if(!(this.option.prohibitList&&this.option.prohibitList.length>0)){
        this.option.prohibitList = []
      }
      this.choiceModel = this.option.model
      this.calculateModel()
    },
    searchRecord(){
      document.body.addEventListener('click',()=>{
        if(this.searchResultVisible){
          this.searchResultVisible = false
        }
      })
       this.searchResultDeptList = []
      this.searchData()
       this.searchResultDeptList.forEach((item)=>{
               this.searchLightHeight(item)
           })
      this.searchResultVisible = !this.searchResultVisible
      try{
         let dom = document.getElementsByClassName('el-popover el-popper')[1]
          dom.style.width = "22%"
       }catch{
         return
       }
    },
    searchLightHeight(item){
      let reg = new RegExp(this.searchFrom.value,'g');
      let replaceValue = '<span class="search-color">'+this.searchFrom.value+'</span>';
     
      item.nameCopy = item.title.replace(reg,replaceValue);
     
    },
    //导航栏点击
    navBarClick(item, index) {
      item.isAllCheck = false
      if (this.navigationBarList.length == 1) {
        return;
      }
      
      console.log('点击盗汗蓝', item);
     
      this.nowDeptList = item.children;
      this.currentObjectDept = item;
     
      for(let i= this.navigationBarList.length-1;i>index;i--){
        this.calculateSelectStatus(this.navigationBarList[i])
        this.easyCalculateSum(this.navigationBarList[i])
      }
      
       //删除导航栏后面的值
      this.removeNavBar(index);
    },
    //删除导航栏后面的值
    removeNavBar(index) {
      this.navigationBarList.splice(index + 1, this.navigationBarList.length - index);
    },
    //推入导航栏
    pushNavBar(obj,data) {
      data.push(obj);
    },
    //给部门增加一些字段
    addField(data){
      data.forEach(item=>{
         this.$set(item, 'isChecked', false);
         this.$set(item, 'checkSum', 0);
         this.$set(item, 'isAllCheck', false);
         this.$set(item, 'halfCheck', false);
         if(item.hasChildren){
             this.$set(item, 'userSum', item.children.length);
             item.children.forEach(childrenItem=>{
               childrenItem.parent = item
             })
             this.addField(item.children)
         }else{
             this.$set(item, 'userSum', 0);
         }
      })
    },
    //加载部门
    getDeptTree() {
      if(this.option.deptId){
         treeByDeptId({ projectId: this.option.projectId,deptId:this.option.deptId }).then((res) => {
        this.deptData = res.data[0];
        this.pushNavBar(res.data[0],this.navigationBarList);
        
        this.addField(this.deptData.children)
        this.deptData.children.forEach(item=>{
          item.parent = this.deptData
        })
        this.nowDeptList = this.deptData.children;
        this.currentObjectDept = this.deptData;
        console.log('加载的部门列表++++', this.currentObjectDept);
      });
      }else{
        treeByProjectDeptId({ projectId: this.option.projectId }).then((res) => {
        this.deptData = res.data[0];
        this.pushNavBar(res.data[0],this.navigationBarList);
        
        this.addField(this.deptData.children)
        this.deptData.children.forEach(item=>{
          item.parent = this.deptData
        })
        this.nowDeptList = this.deptData.children;
        this.currentObjectDept = this.deptData;
        console.log('加载的部门列表++++', this.currentObjectDept);
      });
      }
      
    },
    //搜索逻辑
    searchData(){
        if(this.searchFrom.value==''){
            return
        }
        if(this.deptData.hasChildren){
             this.getSearchData(this.deptData.children)
        }
         
    },
    //递归拿到搜索结果
    getSearchData(data){
        // console.log('shou--',data)
         data.forEach(item=>{
            if(item.title.indexOf(this.searchFrom.value)>-1){
                this.searchResultDeptList.push(item)
            }
            if(item.hasChildren){
                this.getSearchData(item.children)
            }
        })
    },
    //选择部门后将部门下面的说有人员和子部门全部删除
    removeDeptAllitem(dept){
      //第一步删除人员
      if(dept.hasChildren){
        dept.children.forEach(item=>{
           let deleteNum = -1
           this.selectDeptList.forEach((selectItem,index)=>{
             if(item.id==selectItem.id){
               deleteNum = index
             }
           })
           if(deleteNum>=0){
            this.selectDeptList.splice(deleteNum,1)
          }
          this.removeDeptAllitem(item)
        })
      }else{
          return
      }
    },
    //点击部门复选框
    clickCheckBox(value,data) {
      console.log('???888?', value);
      if (!value.isChecked) {
        console.log('no')
        value.halfCheck = false
        value.checkSum = 0
        this.setDeptStatus(value,false)
        this.removeItemFormData(value, data);
      } 
      else {
        console.log("yes")
        if(this.option.prohibitList.length>0){
          for(let i =0;i<this.option.prohibitList.length;i++){
              if(this.option.prohibitList[i].id==value.id){ 
                this.$message({
                  message: '禁止选择该部门',
                  type: 'warning'
                  });
                 this.$nextTick(()=>{
                  this.$set(  value,'isChecked',false)
                })
                return
              }
          }
        
        }
        if(this.choiceModel =="dept"){
            if(data.length == this.option.limit){
            this.$message({
            message: '选择部门已达上限',
            type: 'warning'
            });
            this.$nextTick(()=>{
              this.$set(  value,'isChecked',false)
            })
            
                
            return
            }
        }
        value.halfCheck = false
           if(value.children){
             value.checkSum =value.userSum
             //父级计算
           }
           //清空父级下面的所有子集
           //this.removeDeptAllitem(value)
          if(this.choiceModel == "singleDept"){
            this.singleModelOperatorSelect(value,data)     
          }else{
            this.insertItemToData(value,data)
          }
        this.setDeptStatus(value,true)
        
      }
      this.$nextTick(()=>{
        value.parent.isAllCheck = true
        value.parent.children.forEach(item=>{
          if(!item.isChecked){
            value.parent.isAllCheck = false
          }
        })
      })
      this.$forceUpdate();
      
      this.calculatePeopleSum()
    },
    //选中部门，部门下面的所有子部门都变成相同状态
    setDeptStatus(dept,flag){
      console.log("变成相同状态",flag)
      //产品新需求，不需要进行全选和半选
      // if(dept.peopleListInfo&&dept.peopleListInfo.peopleList.length>0){
      //    dept.peopleListInfo.peopleList.forEach(peo1=>{
      //         peo1.isChecked = flag 
      //       })
      // }
      // if(dept.hasChildren){
      //   dept.children.forEach(item=>{
      //     item.isChecked = flag
      //     if(item.peopleListInfo&&item.peopleListInfo.peopleList.length>0){
      //       item.peopleListInfo.peopleList.forEach(peo=>{
      //         peo.isChecked = flag 
      //       })
      //     }
      //    if(item.hasChildren){
      //       this.setDeptStatus(item,flag)
      //    }
      //   })
      // }
      
    },
    calculateSingleSelectSum(obj,num){
      if(obj){
        obj.checkSum =num
        if(num ==-1){
          console.log("等于-1")
        }
        console.log("部门",obj.title,obj.checkSum,obj.parent)
        if(obj.parent){

          this.calculateSingleSelectSum(obj.parent,num)
        }else{
          console.log("没有上级的单选：")
          console.log("没有上级的单选：",obj.realName||obj.title)
        }
        }
      
    },
    calculateSelectDeptSum(obj,num,type){
      if(obj){
        
        if(type=="add"){
          console.log("部门",obj.title,obj.checkSum)
        obj.checkSum += num
        if(obj.parent){

          this.calculateSelectDeptSum(obj.parent,num,type)
        }
      }else{
        obj.checkSum -= num
        if(obj.parent){
          this.calculateSelectDeptSum(obj.parent,num,type)
        }
      }
      }
    },
    calculateSelectSum(obj,type){
     
         if(type=="add"){
        obj.checkSum++
        if(obj.parent){
          this.calculateSelectSum(obj.parent,type)
        }
      }else{
       
        obj.checkSum--
        if(obj.parent){
          this.calculateSelectSum(obj.parent,type)
        }
      }

     
    },

    //单选模式操作已选的
    singleModelOperatorSelect(item,selectList){
      
      selectList.forEach(item_=>{
        item_.isChecked = false
        this.calculateSelectStatus(item_.parent)
        this.setDeptStatus(item_,false)
        this.calculateSingleSelectSum(item_.parent,0)
      })
      item.isChecked = true
      selectList.splice(0,selectList.length)
      selectList.push(item)
      
      console.log("单选模式的结果selectList",selectList)
       console.log("单选模式的结果selectPeopleList",this.selectPeopleList)
    },
    
     //点击搜索人员复选框
    clickSearchDeptCheckBox(value,data) {
     console.log("部门",value)
      if (!value.isChecked) {
        this.removeItemFormData(value, data);
        
        //  this.$set(value,'isChecked',true)
      } else {
        if(this.option.prohibitList.length>0){
        for(let i =0;i<this.option.prohibitList.length;i++){
            if(this.option.prohibitList[i].id==value.id){
              value.isChecked =false
              this.$message({
                message: '禁止选择该部门',
                type: 'warning'
                });
              return
            }
        }
       
      }
        if(this.choiceModel =="people"){
        if(data.length == this.option.limit){
          value.isChecked = false
          this.$message({
          message: '选择部门已达上限',
          type: 'warning'
          });
          return
        }
      }
        console.log("模式",this.choiceModel)
        if(this.choiceModel == "singleDept"){
          this.singleModelOperatorSelect(value,this.selectDeptList)
        }else{
          this.insertItemToData(value,data)
        }
        
        //  this.$set(value,'isChecked',false)
      }
      value.parent.isAllCheck = true
      value.parent.children.forEach(item=>{
        if(!item.isChecked){
          value.parent.isAllCheck = false
        }
      })
        this.calculateSelectStatus(value.parent)
      
      this.calculatePeopleSum()
    },
    //计算全选和半选
    calculateSelectStatus(item){
      //产品方面又不需要全选和半选
      // item.isChecked = false
      // item.isAllCheck = false
      // item.halfCheck = false
      // console.log('全选和半选',item.title)
      // let childrenCheckFlag = false
      // let childrenCheckHalfFlag = false
      // if(item.hasChildren){
      //   let checkedDeptNum =0
      //   item.children.forEach(deptItem=>{
      //     if(deptItem.isChecked){
      //         checkedDeptNum++
      //     }
      //     if(deptItem.halfCheck){
      //       item.halfCheck = true
      //     }
      //   })
      //   if(checkedDeptNum==item.children.length){
      //     childrenCheckFlag =true
      //   }else{
      //     if(checkedDeptNum>0&&checkedDeptNum<item.children.length){
      //       childrenCheckHalfFlag = true
      //     }
      //   }
      // }
      // if(childrenCheckFlag){
      //     item.isAllCheck=true
      //     item.isChecked = true
      //     item.halfCheck = false
      //     item.checkSum = item.userSum
      // }else{
      //     if(childrenCheckHalfFlag){
      //         item.isAllCheck=false
      //         item.isChecked = false
      //         item.halfCheck = true
      //     }
      // }
    },
   
    //点击下级
    goSubordinate(obj) {
      
      if (obj.isChecked) {
        return;
      }
      obj.isAllCheck = false
      //给所有子级加上parent指向
      if(obj.children&&obj.children.length>0){
        obj.children.forEach(item=>{
          this.$set(item,'parent',obj)
        })
      }
      
      this.pushNavBar(obj,this.navigationBarList);
      this.nowDeptList = obj.children;
      this.currentObjectDept = obj;
      console.log('这是所有数据集合', this.deptData);
    },
    
    
    //数组插入元素（去重）全选
    insertItemToData(item, targetArry) {
      let flag = false;
      let itemIndex = -1
      item.isChecked = true;
      targetArry.forEach((item_,index) => {
        if (item.id == item_.id) {
          itemIndex = index;
          item_.isChecked = false;
         
        }
      });
       if (itemIndex >= 0) {
        
        if(targetArry[itemIndex].parent){
          // this.calculateSelectSum(targetArry[itemIndex].parent,"reduce")
        }
        
        targetArry.splice(itemIndex, 1);
      }
      targetArry.push(item)
      targetArry[targetArry.length-1].isChecked = true
     
    },
    //将一个集合插入到另一个集合 全选 targetArry:已选的集合
    mergeArry(arry, targetArry) {
      console.log("合并员",arry)
      if (arry&&arry.length>0) {
        arry.forEach((item) => {
          item.isChecked = true
         item.checkSum = item.userSum || 0
          item.halfCheck = false
          this.insertItemToData(item, targetArry);
        });
      }
    },
    //已选择的集合移除选中 item ：树形集合中的元素
    removeItemFormData(item, data) {
      console.log('调用了移除',item);
      let itemIndex;
      data.forEach((item_, index) => {
        if (item.id == item_.id) {
          itemIndex = index;
          item_.isChecked = false;
        }
      });
      if (itemIndex >= 0) {
        data.splice(itemIndex, 1);
      }
       
      if(item.children){//深度移除所有的部门和人员
        this.removeArry(item.children,data)
      }
      this.calculatePeopleSum()

    },
    removeArry(arry, targetArry) {
      if (arry.length>0) {
        arry.forEach((item) => {
          item.isAllCheck = false;
          item.halfCheck = false;
          item.checkSum = 0
          item.isChecked = false; //取消选中
          this.removeItemFormData(item, targetArry);
        });
      }
    },
    easyCalculateSum(dept){
      console.log("jisuanqq",dept)
      dept.checkSum = 0
      if(dept.hasChildren){
        dept.children.forEach(item=>{
          dept.checkSum +=item.checkSum
        })
      } 
    },
    
    handleCheckAllChange() {
      this.currentObjectDept.halfCheck = false
      
      if (this.currentObjectDept.isAllCheck) {
        console.log("yes",this.currentObjectDept)
        this.currentObjectDept.checkSum =this.currentObjectDept.userSum
      
        // this.currentObjectDept.isChecked = true
        // this.setDeptStatus(this.currentObjectDept,this.currentObjectDept.isAllCheck)
        //将当前部门所有人员和下属部门进行插入到已选择的集合中
        if(this.currentObjectDept.hasChildren){
          this.mergeArry(this.currentObjectDept.children, this.selectDeptList);
        this.currentObjectDept.children.forEach(item=>{
          //删除子部门
          this.removeDeptAllitem(item)
        })
       }
        this.removeProhibit()
      } else {
        console.log("no")
        this.currentObjectDept.checkSum =0
        this.currentObjectDept.isChecked = false
        this.currentObjectDept.checkSum = 0
        if(this.currentObjectDept.children){
          this.removeArry(this.currentObjectDept.children, this.selectDeptList);
        }
      }
      this.calculatePeopleSum()
    },
    //全选删除禁止选择的人
    removeProhibit(){
      let data 
      data = this.selectDeptList
      if(this.option.prohibitList.length>0){
        for(let i=0;i< this.option.prohibitList.length;i++){
          let removeIndex =-1
          data.forEach((item,index)=>{
            if(item.id == this.option.prohibitList[i].id){
              item.isChecked = false
              removeIndex = index
            }
          })
          if(removeIndex>=0){
             data.splice(removeIndex,1)
          }
        }
        this.$message('已过滤')
      }
    },
    //全选计算数量（只用计算当前部门层级下面的数据其余不需要关心）
    calculateAllSelectSum(dept){
      if(dept.children){
        dept.children.forEach(item=>{
        item.checkSum = item.userSum
        item.halfCheck = false
      })
      }
    },
    submitSelect(){
      this.$emit("getSelectList",this.selectDeptList)
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style>
#choicePeopleComponent .el-checkbox {
  margin-right: 8px !important;
}
</style>

<style lang="scss" scoped>
::v-deep .el-popper[x-placement^=bottom]{
  width: 22%;
}
.subordinateLable{
  margin-right: 24px;
  color: #409EFF;
}
.dept {
  height: 466px;
  overflow: scroll;
}
.team{
   height: 466px;
  overflow: scroll;
}
.selectInfo {
  height: 440px;
  overflow: scroll;
  width:100%;
  padding: 0 12px;
  .selectItem{
      float: left;
      margin-right: 8px;
      margin-bottom: 8px;
  }
}
.navigation_bar {
  display: flex;
  flex-wrap: wrap;
}
.el-checkbox-group {
  display: grid;
  grid-template-rows: 1fr;
  grid-row-gap: 16px;
  .choice_item {
    display: flex;
    justify-content: space-between;
  }
}
::v-deep .el-checkbox__label {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px !important;
}
.searchResult{
  
  max-height: 336px;
  width: 100%;
  overflow: scroll;
  .searchChoice_item{

  }
}
::v-deep .search-color{
	color:#409EFF;
    display:inline-block;
}
</style>
